import type { FC } from 'react';
import { Image, VStack } from '@chakra-ui/react';

import safeImg from 'assets/brand/safe.png';
import useAuthenticatedAction from 'common/hooks/useAuthenticatedAction';
import { Params } from 'common/hooks/useAuthenticatedAction/types';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import DetailSidebar, { DetailSidebarProps } from 'components/DetailSidebar';
import Loader from 'components/Loader';
import PasscodeInput from 'components/PasscodeInput';

import locales from './locales';

type Props = Omit<DetailSidebarProps, 'children'> &
  Pick<Params, 'scope' | 'onPasscodeSuccess'> & {
    description?: string;
  };

const PasscodeDetailSidebar: FC<Props> = ({
  description,
  onPasscodeSuccess,
  scope,
  ...props
}) => {
  const { isLoading, onPasscodeSubmit } = useAuthenticatedAction({
    onPasscodeSuccess,
    scope,
  });

  return (
    <DetailSidebar {...props} variant="ghost">
      <DetailSidebar.Header />
      <DetailSidebar.Body>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <VStack
              alignItems="flex-start"
              gap="space-8"
              marginBottom="space-16"
            >
              <Image alt="" role="presentation" src={safeImg} width="80px" />
              <Heading>{locales.heading}</Heading>
              {description ? <Text>{description}</Text> : null}
            </VStack>
            <PasscodeInput hidden onSubmit={onPasscodeSubmit} />
          </>
        )}
      </DetailSidebar.Body>
    </DetailSidebar>
  );
};

export default PasscodeDetailSidebar;
